import axios from 'axios'
import { push } from 'connected-react-router'
import mapValues from 'lodash/mapValues'
import { fetchCurrentUser } from './authActions.ts'
import { serializeSearchState, deserializeSearchQuery } from './utils/search'
import { sendNotification } from './notificationActions'

const itemTypeFromData = ({ story_id }) => (story_id ? 'Story' : 'Listing')

export function addToMyBucketlist(data) {
  return (dispatch) => {
    return dispatch({
      type: 'BUCKET_LIST_ADD',
      payload: axios
        .post('/user/bucket_list/add', data)
        .then((response) => dispatch(fetchCurrentUser()).then(() => response)),
      meta: {
        auth: 'modal',
        replay: () => addToMyBucketlist(data),
      },
    }).then(() => {
      dispatch(
        sendNotification(
          `${itemTypeFromData(
            data
          )} has been added to your <a href="/my/bucketlist">Bucket List</a>.`,
          null,
          3000
        )
      )
    })
  }
}

export function removeFromMyBucketlist(data) {
  return (dispatch) => {
    return dispatch({
      type: 'BUCKET_LIST_REMOVE',
      payload: axios
        .post('/user/bucket_list/remove', data)
        .then((response) => dispatch(fetchCurrentUser()).then(() => response)),
      meta: {
        auth: 'modal',
        replay: () => removeFromMyBucketlist(data),
      },
    }).then(() => {
      dispatch(
        sendNotification(
          `${itemTypeFromData(
            data
          )} has been removed from your <a href="/my/bucketlist">Bucket List</a>.`,
          null,
          3000
        )
      )
    })
  }
}

export function fetchMyBucketlist() {
  return (dispatch, getState) => {
    const { myBucketlist } = getState()
    return dispatch({
      type: 'MY_BUCKETLIST_FETCH',
      payload: axios('/user/bucket_list', {
        params: {
          ...myBucketlist.filters,
        },
      }),
      meta: {
        filters: myBucketlist.filters,
      },
    })
  }
}

function updateQueryString() {
  return (dispatch, getState) => {
    const { myBucketlist } = getState()
    const newQuery = serializeSearchState(myBucketlist.filters)
    dispatch(
      push({
        search: newQuery,
      })
    )
  }
}

export function initializeFromQueryString(queryString) {
  return (dispatch) => {
    const newState = deserializeSearchQuery(queryString)

    return dispatch({
      type: 'BUCKET_LIST_INITIALIZE_FROM_QUERY_STRING',
      payload: newState,
    })
  }
}

export function updateFilters(newFilters) {
  return (dispatch) => {
    dispatch({
      type: 'BUCKET_LIST_FILTERS_UPDATE',
      meta: {
        newFilters,
      },
      payload: newFilters,
    })
    dispatch(updateQueryString())
  }
}

// Alias for changing a single filter
export function updateFilter(key, value) {
  return (dispatch) => {
    const newFilters = {}
    newFilters[key] = value
    dispatch(updateFilters(newFilters))
  }
}

export function resetFilters() {
  return (dispatch, getState) => {
    const {
      myBucketlist: { filters },
    } = getState()
    const newFilters = mapValues(filters, () => null)
    dispatch(updateFilters(newFilters))
  }
}
